import { Signal } from "@preact/signals";
import IconX from "tabler-icons/x.tsx";
import type { FileData } from "../hooks/useFileHandler.tsx";


export function FilesList({ files }: { files: Signal<FileData[]> }) {
  if (files.value.length == 0) return null;

  function removeFile(i: number) {
    const [file] = files.value.splice(i, 1);
    if (file?.previewUrl) URL.revokeObjectURL(file.previewUrl);
    files.value = [...files.value];
  }

  return <div class="files-list">
    {files.value.map((file, i) =>
      <div class="file">
        {file.previewUrl && <img class="preview" src={file.previewUrl} alt={file.name} />}
        <span class="filename">{file.name}</span> <button onClick={() => removeFile(i)}><IconX height={20} /></button>
      </div>
    )}
  </div>
}
